<template> 
  <div class="container">
    <div class="page-header">
      <h1 class="page-title full">
        Gérer les écocentres <br>
        <p class="lead text-muted">Modifiez les écocentres.</p>
      </h1>
      <div class="page-options d-flex" v-if="isEdit">
        <div class="input-group ml-3 pl-3">
          <button class="btn btn-secondary btn-md" v-on:click.prevent="ajouterEcocentre()"> 
            <i class="fe fe-plus"></i> Ajouter un écocentre
          </button>
        </div>
      </div>
    </div>
    <div class="row row-cards">
      <div class="col-12" v-if="loading"><Spinner></Spinner></div>
      <template v-else>
        <div class="col-4">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Écocentres</h3>
            </div>
            <div class="table-responsive">
              <table class="table card-table table-vcenter text-nowrap">
                <tbody>
                  <tr v-for="item in ecocentres" class="clickable" :key="item.id"
                      v-on:click.prevent="modifierEcocentre(item)">
                    <td>
                      <a href="#"> 
                        {{ item.nom }}
                      </a>            
                    </td>
                    <td class="text-right">
                      <a href="#" class="btn btn-secondary btn-sm">
                        Modifier
                      </a>
                    </td>
                  </tr>
                  <tr v-if="ecocentres.length == 0" class="text-muted">
                    <td colspan="5"><i>Il n'y a aucun écocentre.</i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="card" v-if="ecocentre">
            <div class="card-header">
              <h3 class="card-title" v-if="isEdit">Modifier un écocentre</h3>
              <h3 class="card-title" v-else>Ajouter un écocentre</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label class="form-label">Nom</label>
                    <input type="text" class="form-control" v-model="ecocentre.nom" name="nom"
                      v-validate="'required'" :class="{ 'is-invalid': errors.has('nom') }" data-vv-as="Le nom">
                    <div class="invalid-feedback" v-show="errors.has('nom')">{{ errors.first('nom') }}</div>
                  </div>

                  <div class="form-group">
                    <label class="form-label mb-0">Horaire</label>
                    <small class="help-block text-muted">
                      Horaire et autres informations concernant l'ouverture de cet écocentre.
                    </small>
                    <textarea type="text" class="form-control" v-model="ecocentre.horaire_text">
                    </textarea>
                  </div>

                  <div class="form-group">
                    <label class="form-label mb-0">Lien web</label>
                    <small class="help-block text-muted">
                      Page web de cet écocentre où les utilisateurs seront redirigés.
                    </small>
                    <input type="text" class="form-control" v-model="ecocentre.lien_web" name="lien_web"
                      v-validate="'required'" :class="{ 'is-invalid': errors.has('lien_web') }" data-vv-as="Le lien web">
                    <div class="invalid-feedback" v-show="errors.has('lien_web')">{{ errors.first('lien_web') }}</div>
                  </div>

                  <div class="form-group mb-0">
                    <label class="form-label" v-bind:class="{ 'mb-0': !isEdit }">
                      Adresse physique </label>
                    <small class="help-block text-muted" v-if="!isEdit">
                      Entrer l'adresse avec le plus de précision possible et recherchez avant de soumettre.
                    </small>
                    <div class="input-group mb-2">
                      <input type="text" class="form-control" v-model="ecocentre.adresse" name="adresse"
                        v-validate="'required'" :class="{ 'is-invalid': errors.has('adresse') }" data-vv-as="Le adresse"
                          v-on:keyup.enter.prevent="enterRechercheAdresse()">
                      <span class="input-group-append">
                        <button class="btn btn-secondary" type="button" v-on:click.prevent="enterRechercheAdresse()">
                          Rechercher
                        </button>
                      </span>
                    </div>
                    <div class="invalid-feedback mt-0 mb-3" v-show="errors.has('adresse')">{{ errors.first('adresse') }}</div>

                    <div style='position:relative;'>
                      <div id="map_div" style="height: 500px; width:100%;"></div>
                      <div id='cp-wrap'></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-12 p-2">
                  <button type="submit" class="btn btn-primary" :disabled="!soumettreDisabled"
                      v-on:click.prevent="sauvegarderEcocentre()">
                    Sauvegarder
                  </button>
                  <button type="submit" class="btn btn-secondary" 
                      v-if="isEdit" v-on:click.prevent="annuler()">
                    Annuler
                  </button>

                  <button type="submit" class="btn btn-danger float-right" 
                      v-if="isEdit" v-on:click.prevent="supprimerEcocentre()">
                    Supprimer cet écocentre
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { prettyTime } from '../helpers'
  import arraySort from 'array-sort'
  import Spinner from 'vue-simple-spinner'
  import clone from 'clone'

  const ECOCENTRE_DEFAULTS = {
    nom: '',
    lat: '',
    lng: '',
    lien_web: '',
    adresse: '',
  };

  const INITIAL = {
    "lat": "46.799319",
    "lng": "-71.743374",
    "zoom": 11
  }

  export default {
    components: {
      Spinner,
    },
    data() {
      return {
        loading: true,
        ecocentres: [],
        isEdit: false,
        ecocentre: clone(ECOCENTRE_DEFAULTS),
      }
    },
    created () {
      this.$store.commit("setTitle", "Écocentres");
      this.fetchEcocentres();
      this.ajouterEcocentre();
    },
    computed: {
      soumettreDisabled() {
        return (
          this.ecocentre.nom.length > 0 && 
          this.ecocentre.lat.length > 0 && 
          this.ecocentre.lng.length > 0 && 
          this.ecocentre.lien_web.length > 0 && 
          this.ecocentre.adresse.length > 0
        )
      }
    },
    methods: {
      prettyTime,

      fetchEcocentres() {
        var self = this;
        Promise.all([ 
          self.$http.get('ecocentres') 
        ]).then(function([ ecocentres ]) {
          if (ecocentres && ecocentres.body && ecocentres.body.data) {
            self.ecocentres = ecocentres.body.data;
          }
          self.loading = false;
        })
        .catch(function(err){
          console.log(err);
        });
      },

      ajouterEcocentre() {
        this.ecocentre = clone(ECOCENTRE_DEFAULTS);
        this.isEdit = false;
        if (this.map) {
          this.map.setCenter(new google.maps.LatLng(INITIAL.lat, INITIAL.lng));
          this.map.setZoom(INITIAL.zoom);
        }
        if (this.marker) {
          this.marker.setMap(null);
        }
        this.$validator.reset();
      },

      modifierEcocentre(ecocentre) {
        this.ecocentre = clone(ecocentre);
        this.isEdit = true;
        if (this.marker) {
          this.marker.setMap(null);
        }
        if (this.map) {
          var position = new google.maps.LatLng(
            parseFloat(this.ecocentre.lat), parseFloat(this.ecocentre.lng));
          this.map.setCenter(position);
          this.map.setZoom(15);
          this.marker = new google.maps.Marker({
            map: this.map,
            position: position
          });
        }
      },

      annuler(annuler) {
        this.ecocentre = null;
        this.ajouterEcocentre();
        window.scrollTo(0, 0);
      },

      supprimerEcocentre() {
        var self = this;
        if (self.isEdit && self.ecocentre) {
          if (confirm("Supprimer définitivement cet écocentre? " +
              "Cette action entrainera la perte de tous les emplacement d'horaire pour cet écocentre.")) {
            self.$http.delete(`ecocentres/${self.ecocentre.id}`).then(response => {
              if (response.status == 200) {
                self.$notify.success("L'écocentre a été supprimé.");
                self.fetchEcocentres();
                self.annuler();
              }
            }, response => {
              // error callback
            });
          }
        }
      },

      initMap() {
        //the only global variable
        var self = this;
        var PS = null;

        //make the satellite view google map, center it in Vancouver.
        var map = new google.maps.Map(document.getElementById("map_div"), {
          center: new google.maps.LatLng(INITIAL.lat, INITIAL.lng),
          mapTypeId: google.maps.MapTypeId.HYBRID,
          zoom: parseFloat(INITIAL.zoom),
          streetViewControl: false
        });

        self.map = map;
      },

      enterRechercheAdresse() {
        var self = this;
        if (!self.map) return;
        var recherche = self.ecocentre.adresse;
        var geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address: recherche }, function(results, status) {
          if (status === 'OK') {
            if (results.length > 0) {
              if (self.marker) self.marker.setMap(null);
              var firstResult = results[0];
              var location = firstResult.geometry.location;
              self.map.setZoom(15);
              self.map.setCenter(location);

              self.ecocentre.lng = location.lng().toString();
              self.ecocentre.lat = location.lat().toString();

              self.marker = new google.maps.Marker({
                map: self.map,
                position: location
              });

              self.map.setCenter(location);
            } else {
              // Erreur, pas assez précis
            }
          }
        });
      },

      sauvegarderEcocentre() {
        var self = this;
        self.$validator.validateAll().then((result) => {
          if (result) {
            let ecocentre = self.ecocentre;

            if (self.isEdit) {
              self.$http.post(`ecocentres/${ecocentre.id}`, ecocentre).then(response => {
                if (response.status == 200) {
                  self.$notify.success("L'écocentre a été mis à jour.");
                  self.fetchEcocentres();
                  self.annuler();
                }
              }, response => {
                // error callback
              });
            } else {
              self.$http.post(`ecocentres`, ecocentre).then(response => {
                if (response.status == 200) {
                  self.$notify.success("L'écocentre a été ajouté.");
                  self.fetchEcocentres();
                  self.annuler();
                }
              }, response => {
                // error callback
              });
            }
          }
        });
      },
    },
    watch: {
      loading(val) {
        var self = this;
        if (val == false) {
          setTimeout(function() {
            self.initMap();
          }, 50);
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Ecocentres.vue?08cc97f8